"use strict";

function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
(function (Drupal) {
  Drupal.behaviors.ampersand = {
    attach: function attach(context, settings) {
      var ampersand = context.querySelector('.ampersand');
      if (!ampersand) {
        return;
      }

      // vars
      var ampersandMobile = document.querySelector('.ampersand--mobile');
      var ampersandText = ampersand.querySelectorAll('.ampersand__slide-text');
      var progress = gsap.timeline({
        repeat: -1
      });
      var pager = ampersand.querySelector('.carousel--pager');
      var progressBar = ampersand.querySelector('.progress-bar');
      var slideCount = ampersand.querySelectorAll('.slide-is-left .ampersand__slide-inner').length;

      // helpers
      var reverseNodes = function reverseNodes(parent) {
        parent.append.apply(parent, _toConsumableArray(Array.from(parent.childNodes).reverse()));
      };
      var lastNodeFirst = function lastNodeFirst(parent) {
        var lastItem = parent.querySelector('.ampersand__slide-inner:last-child');
        parent.prepend(lastItem);
      };

      /**
       * Custom scrollbars.
       * @param {Object} element The element add scrollbars.
       */
      var ampersandScroll = function ampersandScroll(element) {
        element.forEach(function (item) {
          item.fakeScroll({
            track: 'smooth'
          });
        });
      };

      /**
       * Vertical Sliders. This is the vertical up/down side by side large slider.
       * Note: Chain in ampersandScroll
       */
      var ampersandSlider = function ampersandSlider() {
        var leftSlider;
        var rightSlider;
        var _rightSlider = ampersand.querySelector('.slide-is-right > div');

        // reorder dom to allow correct pairing
        reverseNodes(_rightSlider);
        lastNodeFirst(_rightSlider);

        // scrollbars
        ampersandScroll(ampersandText);
        leftSlider = tns({
          container: '.slide-is-left > div',
          autoplay: true,
          autoplayTimeout: 10000,
          autoplayButton: false,
          items: 1,
          mouseDrag: false,
          controls: false,
          nav: false,
          axis: 'vertical',
          autoplayHoverPause: false
        });
        rightSlider = tns({
          container: '.slide-is-right > div',
          autoplay: true,
          autoplayTimeout: 10000,
          autoplayButton: false,
          items: 1,
          mouseDrag: false,
          controls: false,
          nav: false,
          axis: 'vertical',
          autoplayHoverPause: false,
          autoplayDirection: 'backwards'
        });
        ampersand.classList.add('is-init');
      };

      /**
       * Build out the dot navigation for the small horizontal slider.
       *
       * @param {Object} element The element to render dots, in this case each slide.
       * @param {number} index The index from the current loop.
       * @param {string} classes Additional classes to the parent element.
       */
      var ampersandDotsBuild = function ampersandDotsBuild(element, index, classes) {
        var count = ampersandMobile.dataset.slides;
        var dots = document.createElement('div');
        dots.classList.add("carousel--pager-mobile", "".concat(classes));
        dots.innerHTML = "\n          ".concat(Array(parseInt(count)).fill().map(function (item, i) {
          return "\n            <button class=\"".concat(index == i + 1 ? 'js-slide-is-active' : '', "\" data-index=\"").concat((i + 1) * 2 - 1, "\">\n              <span class=\"visually-hidden\">Go to slide ").concat((i + 1) * 2 - 1, "</span>\n            </button>\n          ");
        }).join(''), "\n        ");
        element.appendChild(dots);
      };

      /**
       * Navigate the small horizontal slider on the dots.
       * Note: The dot should take you to the first of the group, so we match the data-index
       *
       * @param {Object} slider The element to bind the slide navigation.
       */
      var ampersandDotsNav = function ampersandDotsNav(slider) {
        var btns = ampersandMobile.querySelectorAll('.carousel--pager-mobile button');
        btns.forEach(function (btn, i) {
          btn.addEventListener('click', function () {
            var newIndex = btn.dataset.index - 1;
            slider.goTo(newIndex);
          });
        });
      };

      /**
       * Clone nodes for small slider orientation.
       * Note: We need to stagger the data-index since these are grouped pairs
       */
      var ampersandSliderClone = function ampersandSliderClone() {
        var leftItems = ampersand.querySelectorAll('.slide-is-left .ampersand__slide-inner');
        var rightItems = ampersand.querySelectorAll('.slide-is-right .ampersand__slide-inner');
        leftItems.forEach(function (item, i) {
          ampersandMobile.querySelector("[data-slide=\"".concat((i + 1) * 2 - 1, "\"]")).appendChild(item.cloneNode(true));
          ampersandDotsBuild(ampersandMobile.querySelector("[data-slide=\"".concat((i + 1) * 2 - 1, "\"] .ampersand__slide-inner > div")), i + 1, 'is-white');
        });
        rightItems.forEach(function (item, i) {
          ampersandMobile.querySelector("[data-slide=\"".concat((i + 1) * 2, "\"]")).appendChild(item.cloneNode(true));
          ampersandDotsBuild(ampersandMobile.querySelector("[data-slide=\"".concat((i + 1) * 2, "\"] .ampersand__slide-inner > div")), i + 1);
        });
      };

      /**
       * Init small horizontal slider after we build the dom
       * Note: Chain in ampersandScroll(), ampersandDotsNav()
       */
      var ampersandSliderMobile = function ampersandSliderMobile() {
        var ampersandTextMobile = ampersandMobile.querySelectorAll('.ampersand__slide-content');
        var mobileSlider;
        ampersandScroll(ampersandTextMobile);
        mobileSlider = tns({
          container: '.ampersand--mobile > div',
          items: 1,
          mouseDrag: true,
          controls: false,
          nav: false,
          loop: false
        });
        ampersandMobile.classList.add('is-init');
        ampersandDotsNav(mobileSlider);
      };

      /**
       * Large vertical slider timed pager
       */
      var ampersandPagerInc = function ampersandPagerInc() {
        setInterval(function () {
          Drupal.behaviors.dart_utils.incrementPager(pager, slideCount);
        }, 10000);
      };

      /**
       * Init
       */
      var init = function init() {
        ampersandSliderClone();
        ampersandSliderMobile();
        ampersandSlider();
        ampersandPagerInc();
        Drupal.behaviors.dart_utils.loadProgressBar(progressBar, progress);
      };
      init();
    }
  };
})(Drupal);